import {makeStyles} from '@mui/styles';

const useStyles = makeStyles(theme => ({
    title: {
        textAlign: 'left',
    },
}));

export default useStyles;
